export default __webpack_public_path__ + "static/media/total_players_icon.ede1af28.svg";